import Vue from 'vue';
import Router from 'vue-router';
import AuthService from '@/services/auth';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/auth/Index.vue'),
      children: [
        {
          name: 'Login',
          path: '',
          meta: {
            styled: true,
          },
          component: () => import('@/views/auth/Login.vue'),
        },
      ],
    },
    {
      path: '/iframe',
      component: () => import('@/views/auth/Index.vue'),
      children: [
        {
          name: 'iFramed Login',
          path: '',
          meta: {
            styled: false,
          },
          component: () => import('@/views/auth/Login.vue'),
        },
      ],
    },
    {
      path: '/waybill',
      beforeEnter: (to, from, next) => {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          // check to see if the user is logged in
          // just call the checkAuth method. It will handle things if User is not Authed.  
          AuthService.checkAuth().then((response) => {
            next();
          });
        }
      },
      component: () => import('@/views/portal/Index.vue'),
      children: [
        // Return Form
        {
          path: '',
          name: 'Return Details',
          meta: {
            requiresAuth: true,
            styled: true,
          },
          component: () => import('@/views/portal/LogReturn.vue'),
        },
        {
          name: 'iFramed Return Details',
          path: 'iframe',
          meta: {
            requiresAuth: true,
            styled: false,
          },
          component: () => import('@/views/portal/LogReturn.vue'),
        },
        // Thank You
        {
          path: 'complete',
          name: 'Thank You',
          meta: {
            requiresAuth: true,
            styled: true,
          },
          component: () => import('@/views/portal/ThankYou.vue'),
        },
        {
          name: 'iFramed Thank You',
          path: 'iframe/complete',
          meta: {
            requiresAuth: true,
            styled: false,
          },
          component: () => import('@/views/portal/ThankYou.vue'),
        },
      ],
    },
  ],
});
